<template>
<div style="width: 800px">
  <div style="margin-bottom: 5px;">
    <el-button size="mini" type="primary" @click="setData">保存</el-button>
    <el-button size="mini" type="warning" @click="outCheckin">搬出</el-button>
    <!--      <el-button size="mini" type="info" @click="setData">撤销</el-button>-->
  </div>
  <el-descriptions size="mini" :label-style="{width: '100px'}" :column="2" border>
    <el-descriptions-item label="房产">
      <el-input size="mini" v-model="form.pid" disabled></el-input>
    </el-descriptions-item>
    <el-descriptions-item label="业主编号">
      <el-input size="mini" v-model="form.owner_id" disabled></el-input>
    </el-descriptions-item>
    <el-descriptions-item label="业主名称">
      <el-input size="mini" v-model="form.name" disabled></el-input>
    </el-descriptions-item>
    <el-descriptions-item label="入住人名称">
      <el-input size="mini" v-model="form.checkin_name"></el-input>
    </el-descriptions-item>
    <el-descriptions-item label="入住人编号">
      <el-input size="mini" v-model="form.checkin_num"></el-input>
    </el-descriptions-item>
    <el-descriptions-item label="入住时间">
      <el-date-picker size="mini" type="date" placeholder="选择日期" v-model="form.checkin_time" style="width: 100%;"></el-date-picker>
    </el-descriptions-item>
    <el-descriptions-item label="搬出时间">
      <el-date-picker size="mini" type="date" placeholder="选择日期" v-model="form.out_time" style="width: 100%;"></el-date-picker>
    </el-descriptions-item>
    <el-descriptions-item label="备注">
      <el-input size="mini" v-model="form.remark"></el-input>
    </el-descriptions-item>
    <el-descriptions-item label="附件">
      <UploadFileFJ :list="form.appendix||[]" @success="UploadFileFJSuccess" />
    </el-descriptions-item>
  </el-descriptions>
</div>
</template>

<script>
import UploadFileFJ from "./UploadFileFJ";
export default {
  name: "CustomerCheckin",
  components: {UploadFileFJ},
  data(){
    return{
      form:{},
    }
  },
  props:{
    id:{
      type:Number,
      default(){
        return 0
      }
    }
  },
  mounted() {

  },
  methods:{
    getData(id){
      var that=this;
      ERP.getRequest({url:"admin/CustomerManagement/getCheckin",data:{id:id}},ret=>{
        if(ret.code){
          that.form=ret.data;
        }else{
          this.$msgbox.alert(ret.msg||"查询失败")
        }
      })
    },
    setData(){
      const that = this;
      ERP.postRequest({url:"admin/CustomerManagement/setCheckin",data:that.form},ret=>{
        if(ret.code){
          this.$msgbox.alert(ret.msg||"修改成功")
        }else{
          this.$msgbox.alert(ret.msg||"修改失败")
        }
      })
    },
    outCheckin(){
      const that = this;
      ERP.postRequest({url:"admin/CustomerManagement/outCheckin",data:{id:that.id}},ret=>{
        if(ret.code){
          that.$emit("outCheckin",that.id)
          that.getData(that.id)
        }else{
          this.$msgbox.alert(ret.msg||"查询失败")
        }
      })
    },
    UploadFileFJSuccess(list){
      this.form.appendix=list;
    }
  },
  watch:{
    id(n,o){
      if(n){
        this.getData(n);
      }
    }
  }

}
</script>

<style lang="scss" scoped>
@import url(common.scss);
.el-button{
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/User/CustomerManagement/CustomerCheckin.vue